export default {
  Title: 'What makes #{firstName} a good match?',
};
